// Demo.jsx (filters added: LeadCategory, LeadSource, BatchDay, DemoAttended)
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation , Link } from 'react-router-dom';
import axios from 'axios';
import { Table, Typography, Spin, Alert, Button, Modal, Input, Select,DatePicker  } from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UndoOutlined } from '@ant-design/icons';

// import socket from './../../socket';

const { TextArea,Search  } = Input;
const { Title, Paragraph } = Typography;

const safe = (v) => (v === null || v === undefined || v === '' ? '-' : v);

const formatDate = (d) => {
  if (!d) return '-';
  const date = new Date(d);
  if (!Number.isNaN(date.getTime())) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = date.getFullYear();
    return `${dd}-${mm}-${yy}`;
  }
  return d;
};

const formatDemoRowDate = (row) => {
  // if (row?.DemoDate) return formatDate(row.DemoDate);
  const day = String(row?.Day ?? '').padStart(2, '0');
  let month = row?.Month ?? '';
  if (isNaN(month)) {
    const months = {
      january: '01', february: '02', march: '03', april: '04', may: '05', june: '06',
      july: '07', august: '08', september: '09', october: '10', november: '11', december: '12',
    };
    const mkey = String(month).toLowerCase();
    month = months[mkey] ?? month;
  }
  month = String(month).padStart(2, '0');
  const year = String(row?.Year ?? '');
  if (!day || !month || !year) return '-';
  return `${day}-${month}-${year}`;
};

export default function Demo() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');

  const [showFilters, setShowFilters] = useState(false);

    const base =
     (role === 'ADMIN') ? "/admin-home"
      : "/user-home";

      const fullPath = `${base}/dashboard-demo`

  useEffect(() => {
    const verifyUser = async () => {
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          { email, role, token }
        );
        if (!res.data.success) {
           const errMsg = res?.data?.message || 'Please Login Again.';
                toast.error(errMsg);
          localStorage.removeItem('token');
          localStorage.removeItem('tempToken');
          localStorage.removeItem('email');
          localStorage.removeItem('fullName');
          localStorage.removeItem('role');
          navigate('/login');
        }
      } catch (error) {
        const msg = error?.response?.data?.message || error?.message || 'Please Login Again.';
           toast.error(msg);
        localStorage.removeItem('token');
        localStorage.removeItem('tempToken');
        localStorage.removeItem('email');
        localStorage.removeItem('fullName');
        localStorage.removeItem('role');
        navigate('/login');
      }
    };
    verifyUser();
  }, [navigate, location.pathname, token, email, role]);

  // main state
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sendingKeys, setSendingKeys] = useState(new Set());

  // modal / demoLinks state
  const [modalVisible, setModalVisible] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [demoLinks, setDemoLinks] = useState([]);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedDemoRowKey, setSelectedDemoRowKey] = useState(null);

  // action modal
  const [actionModalVisible, setActionModalVisible] = useState(false);
  const [actionRecord, setActionRecord] = useState(null);
  const [movingKeys, setMovingKeys] = useState(new Set());
  // const [actionResult, setActionResult] = useState(null);

  // drop lead modal
  const [dropModalVisible, setDropModalVisible] = useState(false);
  const [dropComments, setDropComments] = useState('');
  const [dropLoading, setDropLoading] = useState(false);

  // demo status modal
  const [demoStatusModalVisible, setDemoStatusModalVisible] = useState(false);
  const [demoStatusRecord, setDemoStatusRecord] = useState(null);
  const [demoStatusValue, setDemoStatusValue] = useState(null);
  const [demoStatusLoading, setDemoStatusLoading] = useState(false);

  // Call Status modal state
  const [callStatusModalVisible, setCallStatusModalVisible] = useState(false);
  const [callStatusRecord, setCallStatusRecord] = useState(null); // selected lead record
  const [callStatusValue, setCallStatusValue] = useState(null); // 'INTERESTED' | 'NOT INTERESTED' | null
  const [callStatusLoading, setCallStatusLoading] = useState(false);


  const [commentModalVisible, setCommentModalVisible] = useState(false);
  const [commentRecord, setCommentRecord] = useState(null);
  const [commentValue, setCommentValue] = useState("");
  const [commentLoading, setCommentLoading] = useState(false);
  
  // ---------------- filters ----------------
  // text search filters
const [filterEmailText, setFilterEmailText] = useState('');
const [filterFullNameText, setFilterFullNameText] = useState('');
  const [filterCategory, setFilterCategory] = useState(null); // 'STUDENT' | 'PROFESSIONAL' | null
  const [filterSources, setFilterSources] = useState([]); // ['GOOGLE','META',...]
  const [filterBatchDays, setFilterBatchDays] = useState([]); // ['MORNING','EVENING']
  const [filterDemoAttended, setFilterDemoAttended] = useState(null); // 'YES'|'NO'|null
   const [filterAvailabilityMonth, setFilterAvailabilityMonth] = useState(null);
const [filterEnrollmentType, setFilterEnrollmentType] = useState(null);
const [filterLeadStatus, setFilterLeadStatus] = useState(null);
// helper: returns month name (UPPERCASE) from AvailabilityBatch value or '' if cannot parse
// const getMonthNameFromAvailability = (val) => {
//   if (!val && val !== 0) return '';
//   // if it's a Date object
//   if (val instanceof Date && !Number.isNaN(val.getTime())) {
//     return ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'][val.getMonth()];
//   }
//   const s = String(val).trim();
//   if (!s) return '';

//   // Try find a month name in the string
//   const months = {
//     january: 'JANUARY', february: 'FEBRUARY', march: 'MARCH', april: 'APRIL', may: 'MAY', june: 'JUNE',
//     july: 'JULY', august: 'AUGUST', september: 'SEPTEMBER', october: 'OCTOBER', november: 'NOVEMBER', december: 'DECEMBER'
//   };
//   const reMonthWord = /([A-Za-z]{3,9})/g;
//   const matches = s.match(reMonthWord);
//   if (matches && matches.length) {
//     for (const m of matches) {
//       const key = m.toLowerCase();
//       if (months[key]) return months[key];
//     }
//   }

//   // Try common formats with numeric month: e.g. 26-10-2025 or 2025-10-26 or 10/26/2025
//   const numericParts = s.split(/[-\\.]/).map(p => p.trim());
//   if (numericParts.length >= 3) {
//     // Try find a numeric part that looks like month (1..12)
//     for (const part of numericParts) {
//       const n = Number(part);
//       if (!Number.isNaN(n) && n >= 1 && n <= 12) {
//         // if date format ambiguous, prefer middle part when format is DD-MM-YYYY or YYYY-MM-DD
//         const monthIndex = n - 1;
//         return Object.keys(months)[monthIndex].toUpperCase();
//       }
//     }
//   }

//   // fallback: return empty
//   return '';
// };

 

  // Upcoming batch modal state
const [upcomingModalVisible, setUpcomingModalVisible] = useState(false);
const [upcomingModalLoading, setUpcomingModalLoading] = useState(false);
const [upcomingDemoLinks, setUpcomingDemoLinks] = useState([]); // options (same shape as demoLinks)
const [selectedUpcomingDemoKey, setSelectedUpcomingDemoKey] = useState(null);
const [upcomingComments, setUpcomingComments] = useState('');
const [upcomingMovingKey, setUpcomingMovingKey] = useState(null); // single key for UI block


  // ---------------- fetch demo leads (unified) ----------------
  const fetchDemoLeads = async () => {
    if (!token) return [];
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/all-demoleads`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.leads || [];
      const normalized = Array.isArray(data) ? data.map((r, i) => ({ key: `${r.Email ?? 'noemail'}-${i}`, ...r })) : [];
      setLeads(normalized);
      return normalized;
    } catch (err) {
      console.error('Failed to fetch demo leads', err);
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        toast.error('Session expired. Please login again.');
        localStorage.clear();
        navigate('/login');
        return [];
      }
      setError('Failed to load demo leads');
      toast.error('Failed to load demo leads');
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDemoLeads();
  }, [token, location.key]);

  

   const normalize = (v) => {
  if (v === null || v === undefined) return '';
  return String(v).trim().toUpperCase();
};

const filteredLeads = useMemo(() => {
  if (!Array.isArray(leads)) return [];

  // normalize filter controls
  const catF = normalize(filterCategory);
  const sourcesF = (filterSources || []).map((s) => normalize(s));
  const batchDaysF = (filterBatchDays || []).map((d) => normalize(d));
  const demoAttendedF = normalize(filterDemoAttended);
  const availMonthF = normalize(filterAvailabilityMonth);

  const emailText = (filterEmailText || '').trim().toLowerCase();
  const nameText = (filterFullNameText || '').trim().toLowerCase();

  const enrollmentTypeF = normalize(filterEnrollmentType);

  const leadStatusF = normalize(filterLeadStatus);
  // If no filters set at all, return original leads (no mutation)
  const noFilters =
  !catF &&
  (!sourcesF.length) &&
  (!batchDaysF.length) &&
  !demoAttendedF &&
  !availMonthF &&
  !enrollmentTypeF &&
  !emailText &&
  !nameText &&
  !leadStatusF;

  if (noFilters) return leads;

  return leads.filter((r) => {
    // Category single-select
    if (catF) {
      if (normalize(r.LeadCategory) !== catF) return false;
    }

    // Source multi-select
    if (sourcesF.length) {
      const src = normalize(r.LeadSource);
      if (!sourcesF.includes(src)) return false;
    }

    // BatchDay multi-select
    if (batchDaysF.length) {
      const bd = normalize(r.BatchDay);
      if (!batchDaysF.includes(bd)) return false;
    }

    // DemoAttended single
    if (demoAttendedF) {
      if (normalize(r.DemoAttended) !== demoAttendedF) return false;
    }

    // Availability Month filter: match month name inside AvailabilityBatch
    if (availMonthF) {
      const ab = String(r.AvailabilityBatch ?? '').toUpperCase(); // e.g. "26-OCTOBER-2025"
      // look for full month name token
      if (!ab.includes(availMonthF)) return false;
    }

    // Text search: Email (substring, case-insensitive)
    if (emailText) {
      const e = String(r.Email ?? '').toLowerCase();
      if (!e.includes(emailText)) return false;
    }

    // Text search: FullName (substring, case-insensitive)
    if (nameText) {
      const n = String(r.FullName ?? '').toLowerCase();
      if (!n.includes(nameText)) return false;
    }

   // EnrollmentType (single)
if (enrollmentTypeF) {
  const et = normalize(r.EnrollmentType || "");

  if (!et.includes(enrollmentTypeF)) return false;
}

if (leadStatusF) {
  const et = normalize(r.LeadStatus || "");

  if (!et.includes(leadStatusF)) return false;
}

    return true;
  });
}, [
  leads,
  filterCategory,
  filterSources,
  filterBatchDays,
  filterDemoAttended,
    filterEnrollmentType,
  filterAvailabilityMonth,
  filterEmailText,
  filterFullNameText,
  filterLeadStatus
]);

const [leadStatusModalVisible, setLeadStatusModalVisible] = useState(false);
const [leadStatusRecord, setLeadStatusRecord] = useState(null);
const [leadStatusValue, setLeadStatusValue] = useState(null);
const [leadStatusLoading, setLeadStatusLoading] = useState(false);



  // ------------- columns (kept mostly same as yours) -------------
  const demoColumns = [
    { title: <span className="text-[17px] font-bold text-white ">Full Name</span>, dataIndex: 'FullName', key: 'FullName', width: 240, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Email</span>, dataIndex: 'Email', key: 'Email', width: 280, render: (t) => <span className="font-bold text-center whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Phone Number</span>, dataIndex: 'PhoneNumber', key: 'PhoneNumber', width: 160, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Lead Category</span>, dataIndex: 'LeadCategory', key: 'LeadCategory', width: 150, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Lead Date</span>, dataIndex: 'LeadDate', key: 'LeadDate', width: 120, render: (d) => <span className="font-extrabold text-center text-blue-600 whitespace-nowrap">{safe(d)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Lead Source</span>, dataIndex: 'LeadSource', key: 'LeadSource', width: 210, render: (t) => <span className="ml-5 whitespace-nowrap">{safe(t)}</span> },
    
{
  title: (
    <span className="text-[17px] font-bold text-white">
      Lead Status
    </span>
  ),
  dataIndex: "LeadStatus",
  key: "LeadStatus",
  width: 240,
  align: "center",
  render: (t, record) => {
    const raw = t ?? "PENDING";
    const value = String(raw).trim().toUpperCase();

    const statusStyles = {
      "HOT LEAD": {
        backgroundColor: "#16a34a", // green
        borderColor: "#16a34a",
        color: "#fff",
      },
      "WARM LEAD": {
        backgroundColor: "#f97316", // orange
        borderColor: "#f97316",
        color: "#fff",
      },
      "COLD LEAD": {
        backgroundColor: "#000000", // black
        borderColor: "#000000",
        color: "#fff",
      },
      "PENDING": {
        backgroundColor: "#dc2626", // red
        borderColor: "#dc2626",
        color: "#fff",
      },
    };

    const style = statusStyles[value] || statusStyles["PENDING"];

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setLeadStatusRecord(record);

            const cur = String(record?.LeadStatus ?? "")
              .trim()
              .toUpperCase();

            setLeadStatusValue(cur && cur !== "PENDING" ? cur : null);
            setLeadStatusModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold shadow-sm whitespace-nowrap"
          style={{ minWidth: 140, ...style }}
        >
          {value}
        </button>
      </div>
    );
  },
},
{
  title: (
    <span className="text-[17px] font-bold text-white">
      Call Status
    </span>
  ),

  dataIndex: "CallStatus",

  key: "CallStatus",

  width: 210,

  align: "center",

  render: (t, record) => {

    const status =
      String(t ?? "PENDING").toUpperCase();

    let style = {
      backgroundColor: "#6b7280",
      borderColor: "#6b7280",
      color: "#fff",
    };

    // ================= STATUS COLORS =================

    switch (status) {

      case "PENDING":

        style = {
          backgroundColor: "#dc2626",
          borderColor: "#dc2626",
          color: "#fff",
        };

        break;

      case "INTERESTED":

        style = {
          backgroundColor: "#16a34a",
          borderColor: "#16a34a",
          color: "#fff",
        };

        break;

      case "NOT INTERESTED":

        style = {
          backgroundColor: "#111827",
          borderColor: "#111827",
          color: "#fff",
        };

        break;

      case "FOLLOW UP":

        style = {
          backgroundColor: "#ca8a04",
          borderColor: "#ca8a04",
          color: "#fff",
        };

        break;

      case "CONNECT TO INSTRUCTOR":

        style = {
          backgroundColor: "#2563eb",
          borderColor: "#2563eb",
          color: "#fff",
        };

        break;

      default:

        style = {
          backgroundColor: "#6b7280",
          borderColor: "#6b7280",
          color: "#fff",
        };

    }
    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            // open modal for this record
            setCallStatusRecord(record);
            // preselect non-PENDING states, otherwise leave null
            const cur = String(record?.CallStatus ?? 'PENDING').toUpperCase();
            setCallStatusValue(cur !== 'PENDING' ? cur : null);
            setCallStatusModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm text-sm"
          style={{ minWidth: 210, ...style }}
        >
          {status}
        </button>
      </div>
    );
  },
},

{
  title: <span className="text-[17px] font-bold text-white">Comment</span>,
  dataIndex: "Comment",
  key: "Comment",
  width: 360,
  align: "center",
  render: (t, record) => {
    const comment = t || "No comment";

    return (
      <div className="flex flex-col items-center gap-2">
        <span className="max-w-[290px] truncate text-sm font-semibold text-gray-700">
          {comment}
        </span>

        <Button
          size="small"
          type="primary"
          onClick={() => {
            setCommentRecord(record);
            setCommentValue(record?.Comment || "");
            setCommentModalVisible(true);
          }}
          className="!bg-purple-700 hover:!bg-purple-900 !font-bold"
        >
          Update
        </Button>
      </div>
    );
  },
},

{
  title: (
    <span className="text-[17px] font-bold text-white">
      Enrollment Type
    </span>
  ),
  dataIndex: "EnrollmentType",
  key: "EnrollmentType",
  width: 260,
  align: "center",
  render: (t, record) => {
    const raw = t ?? "PENDING";
    const value = String(raw).toUpperCase();

    const isPending = value === "PENDING" || value === "" || value === null;

const isJunior = record?.EnrollmentType === "JUNIOR PENETRATION TESTER";

const style2 = isJunior
  ? { backgroundColor: "#2563eb", borderColor: "#2563eb", color: "#fff" }
  : { backgroundColor: "#16a34a", borderColor: "#16a34a", color: "#fff" };

const style = isPending
  ? { backgroundColor: "#dc2626", borderColor: "#dc2626", color: "#fff" }
  : style2;

     
      
    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            // store the full row in modal state
            setEnrollmentRecord(record);

            // preselect only if real value exists
            const cur = String(record?.EnrollmentType ?? "")
              .trim()
              .toUpperCase();

            setEnrollmentValue(
              cur && cur !== "PENDING" ? cur : null
            );

            setEnrollmentModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm"
          style={{ minWidth: 140, ...style }}
        >
          {value === "" ? "-" : value}
        </button>
      </div>
    );
  },
}
,
   {
  title: (
    <span className="text-[17px] font-bold text-white">
      Availability Batch
    </span>
  ),
  dataIndex: "AvailabilityBatch",
  key: "AvailabilityBatch",
  width: 220,
  align: "center",
  render: (t, record) => (
    <div className="flex flex-col items-center gap-1">
      <span className="font-bold text-green-700 whitespace-nowrap">
        {safe(t)}
      </span>

      <button
        type="button"
        onClick={() => {
          setChangeBatchRecord(record);
          setChangedBatchDate(null);
          setChangeBatchModalVisible(true);
        }}
        className="px-2 py-0.5 text-xs font-semibold text-white border bg-red-600 border-slate-600 rounded hover:bg-blue-600 hover:text-white"
      >
        Change
      </button>
    </div>
  ),
}
,
    { title: <span className="text-[17px] font-bold text-white">Batch Day</span>, dataIndex: 'BatchDay', key: 'BatchDay', width: 120, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },

    { title: <span className="text-[17px] font-bold text-white">Demo Date</span>, dataIndex: 'DemoDate', key: 'DemoDate', width: 130, render: (d) => <span className="font-bold whitespace-nowrap">{safe(d)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Demo Time</span>, dataIndex: 'DemoTime', key: 'DemoTime', width: 160, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },

    { title: <span className="text-[17px] font-bold text-white">Demo Link</span>, dataIndex: 'DemoLink', key: 'DemoLink', width: 300, render: (t) => t ? <a className="truncate inline-block max-w-[260px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },

    {
      title: <span className="text-[17px] font-bold text-white whitespace-nowrap">Send Demo Link</span>,
      key: 'sendDemo',
      width: 180,
      align: 'center',
      render: (_, record) => {
        const isSending = sendingKeys.has(record.key);
        const status = String(record?.DemoLink_1 ?? 'PENDING').toUpperCase();
        const isSent = status === 'SENT';
        const green = { bg: '#16a34a', border: '#16a34a' };
        const red = { bg: '#dc2626', border: '#dc2626' };
        const style = isSending ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' } : isSent ? { backgroundColor: green.bg, borderColor: green.border, color: '#fff' } : { backgroundColor: red.bg, borderColor: red.border, color: '#fff' };

        return (
          <Button
            type="primary"
            onClick={() => openDemoModal(record)}
            disabled={isSending}
            style={{ ...style, padding: '6px 12px', borderRadius: 8, fontWeight: 600 }}
            className="transition-all duration-150"
          >
            {isSending ? <span className="inline-flex items-center gap-2"><Spin size="small" />Sending</span> : (isSent ? 'SENT (Resend)' : 'Send Demo Link')}
          </Button>
        );
      }
    },

    { title: <span className="text-[17px] font-bold text-white">DemoLink_1</span>, dataIndex: 'DemoLink_1', key: 'DemoLink_1', width: 140, render: (t) => <span className={`whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">DemoLink_2</span>, dataIndex: 'DemoLink_2', key: 'DemoLink_2', width: 140, render: (t) => <span className={`whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">DemoLink_3</span>, dataIndex: 'DemoLink_3', key: 'DemoLink_3', width: 140, render: (t) => <span className={`whitespace-nowrap font-semibold ${String(t).toUpperCase() === 'SENT' ? 'text-green-700' : 'text-red-600'}`}>{safe(t)}</span> },

    {
      title: <span className="text-[17px] font-bold text-white">RecordingLink_1</span>,
      dataIndex: 'RecordingLink_1',
      key: 'RecordingLink_1',
      width: 240,
      align: 'center',
      className: 'whitespace-nowrap',
      render: (_, record) => {
        const status = String(record?.RecordingLink_1 ?? 'PENDING').toUpperCase();
        const isSent = status === 'SENT';
        const keyName = `recording-RecordingLink_1-${record.key}`;
        const isSending = sendingKeys.has(keyName);
        const btnStyle = isSending ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' } : isSent ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' } : { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' };

        return (
          <div className="flex justify-center">
            <Button
              onClick={() => handleSendRecordingLink(record, 'RecordingLink_1')}
              disabled={isSent || isSending}
              style={{
                ...btnStyle,
                minWidth: 220,
                whiteSpace: 'nowrap',
                padding: '12px 14px',
                borderRadius: 10,
                fontWeight: 600,
                fontSize: '15px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              className="transition-all duration-200 shadow-sm "
            >
              {isSending ? <span className="inline-flex items-center gap-2"><Spin size="small" />Sending...</span> : isSent ? 'SENT' : 'Send Demo Recording Link'}
            </Button>
          </div>
        );
      },
    },

    // {
    //   title: <span className="text-[17px] font-bold text-white">RecordingLink_2</span>,
    //   dataIndex: 'RecordingLink_2',
    //   key: 'RecordingLink_2',
    //   width: 280,
    //   align: 'center',
    //   className: 'whitespace-nowrap',
    //   render: (_, record) => {
    //     const status = String(record?.RecordingLink_2 ?? 'PENDING').toUpperCase();
    //     const isSent = status === 'SENT';
    //     const keyName = `recording-RecordingLink_2-${record.key}`;
    //     const isSending = sendingKeys.has(keyName);
    //     const btnStyle = isSending ? { backgroundColor: '#9CA3AF', borderColor: '#9CA3AF', color: '#fff' } : isSent ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' } : { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' };

    //     return (
    //       <div className="flex justify-center">
    //         <Button
    //           onClick={() => handleSendRecordingLink(record, 'RecordingLink_2')}
    //           disabled={isSent || isSending}
    //           style={{
    //             ...btnStyle,
    //             minWidth: 220,
    //             whiteSpace: 'nowrap',
    //             padding: '12px 14px',
    //             borderRadius: 10,
    //             fontWeight: 600,
    //             fontSize: '15px',
    //             display: 'inline-flex',
    //             alignItems: 'center',
    //             justifyContent: 'center',
    //           }}
    //           className="transition-all duration-200 shadow-sm "
    //         >
    //           {isSending ? <span className="inline-flex items-center gap-2"><Spin size="small" />Sending...</span> : isSent ? 'SENT' : 'Send Demo Recording Link'}
    //         </Button>
    //       </div>
    //     );
    //   },
    // },

    {
      title: <span className="text-[17px] font-bold text-white">Demo Attended</span>,
      dataIndex: 'DemoAttended',
      key: 'DemoAttended',
      width: 160,
      align: 'center',
      render: (t, record) => {
        const status = String(t ?? '').toUpperCase();
        const isYes = status === 'YES';
        const isNo = status === 'NO';
        const btnStyle = isYes ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' } : isNo ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } : { backgroundColor: '#0ea5a4', borderColor: '#0ea5a4', color: '#fff' };

        return (
          <div className="flex justify-center">
            <button
              onClick={() => openDemoStatusModal(record)}
              className="px-2 py-1.5 rounded-md font-semibold text-white whitespace-nowrap"
              style={{ ...btnStyle, minWidth: 80 }}
              type="button"
            >
              {status ? status : 'Change'}
            </button>
          </div>
        );
      },
    },

    {
      title: (
        <span className="font-bold text-[17px] text-white whitespace-nowrap">
          Action
        </span>
      ),
      key: 'action',
      fixed: 'right',
      width: 220,
      align: 'center',
      render: (_, record) => {
        return (
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => openActionModal(record)}
              className={`px-4 py-2 rounded-md text-white font-semibold transition-colors duration-200 whitespace-nowrap bg-gradient-to-r from-blue-600 to-blue-500 hover:from-red-700 hover:to-rose-600 shadow`}
              type="button"
            >
              Actions
            </button>
          </div>
        );
      },
    }
  ];

  const demoLinksColumns = [
    { title: 'DemoDate', dataIndex: 'DemoDate', key: 'DemoDate', width: 140, render: (d) => <span className="font-bold whitespace-nowrap">{safe(d)}</span> },
    { title: 'Day', dataIndex: 'Day', key: 'Day', width: 80, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Month', dataIndex: 'Month', key: 'Month', width: 100, render: (t) => <span className="font-bold text-amber-600 whitespace-nowrap">{safe(t)}</span> },
    { title: 'Year', dataIndex: 'Year', key: 'Year', width: 100, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Time', dataIndex: 'Time', key: 'Time', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchStartDate', dataIndex: 'BatchStartDate', key: 'BatchStartDate', width: 140, render: (d) => <span className="font-bold text-green-600 whitespace-nowrap">{safe(d)}</span> },
    { title: 'BatchDay', dataIndex: 'BatchDay', key: 'BatchDay', width: 100, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchTime', dataIndex: 'BatchTime', key: 'BatchTime', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'DemoLink', dataIndex: 'DemoLink', key: 'DemoLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
    { title: 'DemoRecordingLink', dataIndex: 'DemoRecordingLink', key: 'DemoRecordingLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
  ];

  // -------------- demo modal flow (unchanged) --------------
  const openDemoModal = async (leadRecord) => {
    setSelectedLead(leadRecord);
    setModalVisible(true);
    setSelectedDemoRowKey(null);
    setDemoLinks([]);
    setModalLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demolinks/all-demolinks`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.links || [];
      setDemoLinks(Array.isArray(data) ? data.map((r, i) => ({ key: r.id ?? `dl-${i}`, ...r })) : []);
    } catch (err) {
      console.error('Failed to fetch demolinks', err);
      toast.error('Failed to load demo options');
    } finally {
      setModalLoading(false);
    }
  };

  const onDemoRowSelect = (selectedRowKeys, selectedRows) => {
    if (selectedRows && selectedRows.length) setSelectedDemoRowKey(selectedRows[0].key);
    else setSelectedDemoRowKey(null);
  };

  // handle modal send (uses fetchDemoLeads to refresh)
  const handleModalSend = async () => {
    if (!selectedLead) {
      toast.error('No lead selected');
      return;
    }
    const selectedRow = demoLinks.find((r) => r.key === selectedDemoRowKey);
    if (!selectedRow) {
      toast.error('Select a demo date option first');
      return;
    }
    const demoDateFormatted = formatDemoRowDate(selectedRow);
    if (demoDateFormatted === '-') {
      toast.error('Selected demo link has invalid date');
      return;
    }
    const payload = { Email: selectedLead.Email, PhoneNumber: selectedLead.PhoneNumber, demoDate: demoDateFormatted };

    setSendingKeys((prev) => new Set(prev).add(selectedLead.key));
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/send-demolink`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res?.data?.success || res?.status === 200) {
        toast.success(res?.data?.message || 'Demo link sent successfully ✅');
        setLeads((prev) => prev.map((r) => (r.key === selectedLead.key ? { ...r, DemoLink_1: 'SENT', DemoLink: res?.data?.demoLink ?? r.DemoLink } : r)));
        setModalVisible(false);
        // refresh server data
        await fetchDemoLeads();
      } else {
        const errMsg = res?.data?.message || 'Failed to send demo link';
        toast.error(errMsg);
      }
    } catch (err) {
      console.error('Failed to send demo link:', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
    } finally {
      setSendingKeys((prev) => {
        const next = new Set(prev);
        next.delete(selectedLead.key);
        return next;
      });
    }
  };

  const handleSelectDemoRow = (record) => {
    if (modalLoading) return;
    setSelectedDemoRowKey(record.key);
  };

  // send recording link
  const handleSendRecordingLink = async (record, which = 'RecordingLink_1') => {
    if (!record?.Email) {
      toast.error('Record missing Email');
      return;
    }
    const rawDate = record?.RecordingDate || record?.DemoDate || new Date();
    const recordingDate = rawDate;
    const payload = { Email: record.Email, PhoneNumber: record.PhoneNumber, recordingDate };

    const keyName = `recording-${which}-${record.key}`;

    setSendingKeys(prev => {
      const next = new Set(prev);
      next.add(keyName);
      return next;
    });

    try {
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/send-recording-link`;
      const res = await axios.put(url, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (res?.data?.success || res?.status === 200 || res?.status === 201) {
        toast.success(res?.data?.message || 'Recording link sent');
        setLeads(prev => prev.map(r => r.key === record.key ? { ...r, [which]: 'SENT', ...(res?.data?.recordingLink ? { [which]: res.data.recordingLink } : {}) } : r));
      } else {
        const errMsg = res?.data?.message || 'Failed to send recording link';
        toast.error(errMsg);
      }
    } catch (err) {
      console.error('send-recording-link error', err);
      if (err?.response) toast.error(err.response?.data?.message || `Server error: ${err.response?.status}`);
      else if (err?.message) toast.error(err.message);
      else toast.error('Network or server error');
    } finally {
      setSendingKeys(prev => {
        const next = new Set(prev);
        next.delete(keyName);
        return next;
      });
    }
  };

  // actions (nurture/upcoming/drop)
  const setMoving = (key, on = true) => {
    setMovingKeys(prev => {
      const next = new Set(prev);
      if (on) next.add(key);
      else next.delete(key);
      return next;
    });
  };

  const callActionApi = async (url, payload) => {
    try {
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 15000,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };

  const handleMoveToNurturing = async (record) => {
    if (!record?.Email) {
      toast.error('No email present for selected lead');
      return;
    }
    const key = `move-nurture-${record.key}`;
    setMoving(key, true);
    try {
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/move-to-nurturing-stage`;
      const payload = { Email: record.Email };
      const res = await callActionApi(url, payload);
      if (res?.data?.success || [200,201].includes(res?.status)) {
        toast.success(res?.data?.message || 'Moved to Nurturing');
        setLeads(prev => prev.filter(r => r.key !== record.key));
    
        setTimeout(() => setActionModalVisible(false), 700);
      } else {
        const msg = res?.data?.message || 'Failed to move';
        toast.error(msg);
       
      }
    } catch (err) {
      console.error('move to nurturing error', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
   
    } finally {
      setMoving(key, false);
    }
  };

  const openUpcomingModal = async (record) => {
  if (!record) return;
  setActionRecord(record); // keep reference
  setUpcomingComments('');
  setSelectedUpcomingDemoKey(null);
  setUpcomingDemoLinks([]);
  setUpcomingModalVisible(true);
  setUpcomingModalLoading(true);

  try {
    // Try to reuse demoLinks if already loaded and not stale
    if (demoLinks && demoLinks.length) {
      setUpcomingDemoLinks(demoLinks);
    } else {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/demolinks/all-demolinks`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.links || [];
      setUpcomingDemoLinks(Array.isArray(data) ? data.map((r, i) => ({ key: r.id ?? `dl-${i}`, ...r })) : []);
    }
  } catch (err) {
    console.error('Failed to load demolinks for upcoming modal', err);
    toast.error('Failed to load batch options');
  } finally {
    setUpcomingModalLoading(false);
  }
};

const handleSelectUpcomingRow = (record) => {
  if (upcomingModalLoading) return;
  setSelectedUpcomingDemoKey(record.key);
};



 const handleConfirmMoveToUpcomingBatch = async () => {
  if (!actionRecord) {
    toast.error('No lead selected');
    return;
  }
  const record = actionRecord;
  const selectedRow = upcomingDemoLinks.find((r) => r.key === selectedUpcomingDemoKey);
  // console.log(selectedRow);
  
  if (!selectedRow) {
    toast.error('Select a batch option first');
    return;
  }

  const AvailabilityBatch = `${selectedRow.BatchStartDate.split("-")[0]}-${selectedRow.Month}-${selectedRow.Year}`
  if (!AvailabilityBatch || AvailabilityBatch === '-') {
    toast.error('Selected batch has invalid date');
    return;
  }

  const BatchDay = selectedRow.BatchDay ;
  const Comments = upcomingComments ;

  const payload = {
    Email: record.Email,
    AvailabilityBatch,
    BatchDay,
    Comments,
  };

  const key = `move-upcoming-${record.key}`;
  setMoving(key, true);
  setUpcomingMovingKey(key);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/move-to-upcoming-batch`;
    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to upcoming batch');
      // remove from UI list
      setLeads(prev => prev.filter(r => r.key !== record.key));
      setUpcomingModalVisible(false);
      setActionModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to move to upcoming batch';
      toast.error(msg);
    }
  } catch (err) {
    console.error('move-to-upcoming-batch error', err);
    const msg = err?.response?.data?.message || err.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setMoving(key, false);
    setUpcomingMovingKey(null);
  }
};

 // Change Call Status API call (PUT)
const handleChangeCallStatus = async () => {
  if (!callStatusRecord || !callStatusRecord.Email) {
    toast.error('No lead selected');
    return;
  }
  if (!callStatusValue) {
    toast.error('Please choose a status');
    return;
  }

  setCallStatusLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/update-call-status`;
    const payload = {
      Email: callStatusRecord.Email,
      CallStatus: callStatusValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Call status updated');

      // update local UI - keep other fields intact
      // setLeads((prev) =>
      //   prev.map((r) => (r.key === callStatusRecord.key ? { ...r, CallStatus: callStatusValue } : r))
      // );

      fetchDemoLeads();

      setCallStatusModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update call status';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-call-status error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setCallStatusLoading(false);
  }
};


 const handleUpdateComment = async () => {
  if (!commentRecord?.Email) {
    toast.error("No lead selected");
    return;
  }

  if (!commentValue.trim()) {
    toast.error("Please enter comment");
    return;
  }

  setCommentLoading(true);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(
      /\/$/,
      ""
    )}/demo/update-comment`;

    const payload = {
      Email: commentRecord.Email,
      Comment: commentValue.trim(),
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Comment updated successfully");

      fetchDemoLeads();

      setCommentModalVisible(false);
      setCommentRecord(null);
      setCommentValue("");
    } else {
      toast.error(res?.data?.message || "Failed to update comment");
    }
  } catch (err) {
    console.error("update-comment error", err);
    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Network/server error"
    );
  } finally {
    setCommentLoading(false);
  }
};
 

  const handleDropLeadConfirm = async (record) => {
    if (!record?.Email) {
      toast.error('No email present for selected lead');
      return;
    }

    const key = `drop-lead-${record.key}`;
    setMovingKeys(prev => {
      const next = new Set(prev); next.add(key); return next;
    });
    setDropLoading(true);

    try {
      const payload = { Email: record.Email, Comments: dropComments ?? '' };
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/drop-lead`;
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (res?.data?.success || [200,201].includes(res?.status)) {
        toast.success(res?.data?.message || 'Lead dropped successfully');
        setLeads(prev => prev.filter(r => r.key !== record.key));
        setDropModalVisible(false);
        setActionModalVisible(false);
      } else {
        const msg = res?.data?.message || 'Failed to drop lead';
        toast.error(msg);
      }
    } catch (err) {
      console.error('Drop lead error', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
    } finally {
      setDropLoading(false);
      setMovingKeys(prev => {
        const next = new Set(prev); next.delete(key); return next;
      });
    }
  };

  const openActionModal = (record) => {
    setActionRecord(record);
    setActionModalVisible(true);
  };

  const openDemoStatusModal = (record) => {
    setDemoStatusRecord(record);
    const cur = String(record?.DemoAttended ?? '').toUpperCase();
    setDemoStatusValue(cur === 'YES' ? 'YES' : cur === 'NO' ? 'NO' : null);
    setDemoStatusModalVisible(true);
  };

  const handleChangeDemoStatus = async () => {
    if (!demoStatusRecord) return toast.error('No record selected');
    if (!demoStatusValue) return toast.error('Select status');

    const payload = { Email: demoStatusRecord.Email, Status: demoStatusValue };

    setDemoStatusLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/demo/change-demo-status`;
      const res = await axios.put(url, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (res?.data?.success || [200,201].includes(res?.status)) {
        toast.success(res?.data?.message || 'Demo status updated');
        setLeads(prev => prev.map(r => r.key === demoStatusRecord.key ? { ...r, DemoAttended: demoStatusValue } : r));
        setDemoStatusModalVisible(false);
      } else {
        toast.error(res?.data?.message || 'Failed to update demo status');
      }
    } catch (err) {
      console.error('change-demo-status error', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
    } finally {
      setDemoStatusLoading(false);
    }
  };

  // Clear filters helper
  const clearFilters = () => {
    setFilterEmailText('');
    setFilterFullNameText('')
    setFilterAvailabilityMonth(null)
    setFilterCategory(null);
    setFilterEnrollmentType(null);
    setFilterSources([]);
    setFilterBatchDays([]);
    setFilterDemoAttended(null);
  };

  // derive counts / badges for toolbar (optional)
  // const showingCount = filteredLeads.length;

 const [enrollmentModalVisible, setEnrollmentModalVisible] = useState(false);
const [enrollmentRecord, setEnrollmentRecord] = useState(null); // entire row object
const [enrollmentValue, setEnrollmentValue] = useState(null);   // selected EnrollmentType
const [enrollmentLoading, setEnrollmentLoading] = useState(false);

// assume you already have these from your component:
// const [leads, setLeads] = useState(...);
// const token = ...; // auth token

// helper to open modal and preselect values
const openEnrollmentModal = (record) => {
  setEnrollmentRecord(record || null);
  setEnrollmentValue(record?.EnrollmentType || null);
  setEnrollmentModalVisible(true);
};

// your handler (as provided, slight adaptation to use local state setters)
const handleChangeEnrollmentType = async () => {
  if (!enrollmentRecord || !enrollmentRecord.Email) {
    toast.error("No lead selected");
    return;
  }
  if (!enrollmentValue) {
    toast.error("Please choose an enrollment type");
    return;
  }

  setEnrollmentLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, "")}/demo/update-enrollment-type`;
    const payload = {
      Email: enrollmentRecord.Email,
      EnrollmentType: enrollmentValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Enrollment type updated");

      // update local leads array (assumes each row has a unique `key` or use Email)
      setLeads((prev) =>
        prev.map((r) =>
          (r.key && enrollmentRecord.key && r.key === enrollmentRecord.key) ||
          ((r.Email || "").toLowerCase() === (enrollmentRecord.Email || "").toLowerCase())
            ? { ...r, EnrollmentType: enrollmentValue }
            : r
        )
      );

      setEnrollmentModalVisible(false);
    } else {
      const msg = res?.data?.message || "Failed to update enrollment type";
      toast.error(msg);
    }
  } catch (err) {
    console.error("change-enrollment-type error", err);
    const msg = err?.response?.data?.message || err?.message || "Network/server error";
    toast.error(msg);
  } finally {
    setEnrollmentLoading(false);
  }
};


const [changeBatchModalVisible, setChangeBatchModalVisible] = useState(false);
const [changeBatchRecord, setChangeBatchRecord] = useState(null);
const [changedBatchDate, setChangedBatchDate] = useState(null);
const [changeBatchLoading, setChangeBatchLoading] = useState(false);

const handleChangeAvailabilityBatch = async () => {
  if (!changeBatchRecord?.Email) {
    toast.error("Email not found");
    return;
  }
  if (!changedBatchDate) {
    toast.error("Please select a date");
    return;
  }

  setChangeBatchLoading(true);
  try {
    const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "");
    const url = `${base}/demo/update-availability-batch`;

    const payload = {
      Email: changeBatchRecord.Email,
      ChangedBatch: changedBatchDate.format("DD-MM-YYYY"),
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.status === 200 || res?.status === 201 || res?.data?.success) {
      toast.success(res?.data?.message || "Batch updated");

      // update table locally
      // setLeads((prev) =>
      //   prev.map((r) =>
      //     (r.Email || "").toLowerCase() ===
      //     (changeBatchRecord.Email || "").toLowerCase()
      //       ? { ...r, AvailabilityBatch: payload.ChangedBatch }
      //       : r
      //   )
      // );

      fetchDemoLeads();

      setChangeBatchModalVisible(false);
    } else {
      toast.error(res?.data?.message || "Failed to update batch");
    }
  } catch (err) {
    console.error("update-batch error", err);
    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Server error"
    );
  } finally {
    setChangeBatchLoading(false);
  }
};


 let juniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'JUNIOR PENETRATION TESTER'
  })

  let seniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'SENIOR PENETRATION TESTER'
  })

  let studentFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'STUDENT'
  })

  let professionalFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'PROFESSIONAL'
  })

const handleChangeLeadStatus = async () => {
  if (!leadStatusRecord?.Email) {
    toast.error("No email found for selected lead");
    return;
  }

  if (!leadStatusValue) {
    toast.error("Please select a lead status");
    return;
  }

  setLeadStatusLoading(true);

  try {
    const payload = {
      Email: leadStatusRecord.Email,
      LeadStatus: leadStatusValue,
    };

    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, "")}/demo/update-Lead-Status`;

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || [200, 201].includes(res?.status)) {
      toast.success(res?.data?.message || "Lead status updated");

      // update table locally
      setLeads(prev =>
        prev.map(l =>
          l.Email === leadStatusRecord.Email
            ? { ...l, LeadStatus: leadStatusValue }
            : l
        )
      );

      setLeadStatusModalVisible(false);
    } else {
      toast.error(res?.data?.message || "Failed to update lead status");
    }
  } catch (err) {
    console.error("Lead status update error", err);
    toast.error(
      err?.response?.data?.message || err.message || "Server error"
    );
  } finally {
    setLeadStatusLoading(false);
  }
};


  return (
    <div className="w-full px-4 py-10 mx-auto bg-white shadow-sm sm:px-6 lg:px-8 rounded-xl">
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        className="!mb-6 !ml-4"
        toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
      />

      <Title level={3} className="!text-3xl !font-bold text-gray-800 tracking-tight mb-3 border-b border-gray-200 pb-2">
        Demo Leads
      </Title>

      <Paragraph className="mb-6 text-lg leading-relaxed text-gray-900">
        This page lists leads which have been moved to the Demo stage. Review demo scheduling,
        send demo links to participants, and track attendance/recordings. Click <strong>Send Demo Link</strong> to pick
        a demo date/time from the available options and send the link to the lead.
      </Paragraph>
      <p className="text-lg text-slate-700">
        You can access all lead details anytime from the{" "}
        <Link
          to={fullPath}
          className="inline-flex items-center gap-2 px-3 py-1 text-lg font-semibold text-red-600 bg-gray-100 rounded-md hover:bg-gray-200"
        >
          Demo Dashboard
        </Link>
      </p>

      {error && <Alert type="error" message="Error" description={error} showIcon closable className="mb-6" />}
 
      <div className="w-full mt-6">
       
       {/* FILTER TOGGLE BUTTON */}
       <div className="flex justify-end mb-3">
         <Button
           onClick={() => setShowFilters(!showFilters)}
           type="primary"
           className="
             font-bold
             px-5
             rounded-lg
             bg-gradient-to-r
             from-blue-700
             via-indigo-700
             to-purple-700
             border-none
             text-white
             shadow-[0_0_20px_rgba(79,70,229,0.8)]
             hover:shadow-[0_0_35px_rgba(79,70,229,1)]
             hover:scale-105
             animate-pulse
             transition-all
             duration-300
           "
         >
           {showFilters ? "Hide Filters" : "Show Filters"}
         </Button>
       </div>
       
       {/* Filters with transition */}
       <div
         className={`overflow-hidden transition-all duration-500 ease-in-out ${
           showFilters
             ? "max-h-[900px] opacity-100 translate-y-0 mb-3"
             : "max-h-0 opacity-0 -translate-y-3 mb-0"
         }`}
       >
       <div className="p-5 border border-blue-100 shadow-[0_10px_35px_rgba(15,23,42,0.12)] bg-gradient-to-br from-white via-slate-50 to-blue-50 rounded-2xl">

      
<div className="flex items-center gap-3 my-6 ml-4">
  {/* FullName Search */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">Full Name</label>
  <Search
    placeholder="Search Full Name"
    allowClear
    value={filterFullNameText}
    onChange={(e) => setFilterFullNameText(e.target.value)}
    onSearch={(v) => setFilterFullNameText(v)}
     style={{
    minWidth: 260,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
    enterButton={false}
  />
</div>

{/* Email Search */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">Email</label>
  <Search
    placeholder="Search email"
    allowClear
    value={filterEmailText}
    onChange={(e) => setFilterEmailText(e.target.value)}
    onSearch={(v) => setFilterEmailText(v)}
    style={{
    minWidth: 260,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
    enterButton={false}
  />
</div>

<div className="flex-grow ml-4 border-2 border-t border-gray-500"></div>
  
</div>       {/* Filters toolbar */}
        <div className="flex flex-col gap-4 mb-7 md:flex-row md:items-center md:justify-between">
         
          <div className="flex flex-wrap items-center gap-3">
            

            {/* Lead Category */}
            <div className="flex items-center gap-2 ml-4">
              <label className="text-sm font-semibold text-gray-700">Lead Category</label>
              <Select
                placeholder={<span style={{ color: '#4b5563' }}>All</span>}
                value={filterCategory}
                onChange={(v) => setFilterCategory(v || null)}
                allowClear
                style={{
    minWidth: 160,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
                options={[
                  { label: 'Student', value: 'STUDENT' },
                  { label: 'Professional', value: 'PROFESSIONAL' },
                ]}
              />
            </div>

            {/* Enrollment Type (single) */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">
    Enrollment Type
  </label>

  <Select
  placeholder={<span style={{ color: '#4b5563' }}>Select Enrollment Type</span>}
  value={filterEnrollmentType}
  onChange={(v) => setFilterEnrollmentType(v ? v.toUpperCase() : null)}
  allowClear
  style={{
    minWidth: 240,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
  options={[
    { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' },
    { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' },
  ]}
/>
</div>

<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">
    Lead Status
  </label>

  <Select
  placeholder={<span style={{ color: '#4b5563' }}>Select Lead Status</span>}
  value={filterLeadStatus}
  onChange={(v) => setFilterLeadStatus(v ? v.toUpperCase() : null)}
  allowClear
  style={{
    minWidth: 240,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
  options={[
    { label: 'PENDING', value: 'PENDING' },
    { label: 'HOT LEAD', value: 'HOT LEAD' },
    { label: 'WARM LEAD', value: 'WARM LEAD' },
    { label: 'COLD LEAD', value: 'COLD LEAD' },
  ]}
/>
</div>


            {/* Lead Source (multi) */}
            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700">Lead Source</label>
              <Select
                mode="multiple"
                placeholder={<span style={{ color: '#4b5563' }}>Select Source</span>}
                value={filterSources}
                onChange={(v) => setFilterSources(v || [])}
                allowClear
                style={{
    minWidth: 160,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
                options={[
                  { label: 'Google', value: 'GOOGLE' },
                  { label: 'Meta', value: 'META' },
                  { label: 'Meta-Instagram', value: 'META-INSTAGRAM' },
             { label: 'Meta-Facebook', value: 'META-FACEBOOK' },
                  { label: 'LinkedIn', value: 'LINKEDIN' },
                  { label: 'Organic', value: 'ORGANIC' },
                  { label: 'Youtube', value: 'YOUTUBE' },
                  { label: 'Youtube-Infeed', value: 'YOUTUBE-YIF' },
                       { label: 'Youtube-Instream', value: 'YOUTUBE-YIS' },
                ]}
              />
            </div>
            
             {/* Availability Batch Month (single) */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">Availability Month</label>
  <Select
    placeholder={<span style={{ color: '#4b5563' }}>Select Month</span>}
    value={filterAvailabilityMonth}
    onChange={(v) => setFilterAvailabilityMonth(v || null)}
    allowClear
    style={{
    minWidth: 140,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
    options={[
      { label: 'JANUARY', value: 'JANUARY' },
      { label: 'FEBRUARY', value: 'FEBRUARY' },
      { label: 'MARCH', value: 'MARCH' },
      { label: 'APRIL', value: 'APRIL' },
      { label: 'MAY', value: 'MAY' },
      { label: 'JUNE', value: 'JUNE' },
      { label: 'JULY', value: 'JULY' },
      { label: 'AUGUST', value: 'AUGUST' },
      { label: 'SEPTEMBER', value: 'SEPTEMBER' },
      { label: 'OCTOBER', value: 'OCTOBER' },
      { label: 'NOVEMBER', value: 'NOVEMBER' },
      { label: 'DECEMBER', value: 'DECEMBER' },
    ]}
  />
</div>


            {/* Batch Day (multi) */}
            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700">Batch Day</label>
              <Select
                mode="multiple"
                placeholder={<span style={{ color: '#4b5563' }}>Select Batch Day</span>}
                value={filterBatchDays}
                onChange={(v) => setFilterBatchDays(v || [])}
                allowClear
                style={{
    minWidth: 160,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
                options={[
                  { label: 'Morning', value: 'MORNING' },
                  { label: 'Evening', value: 'EVENING' },
                ]}
              />
            </div>

                
            {/* Demo Attended (single) */}
            <div className="flex items-center gap-2">
              <label className="text-sm font-semibold text-gray-700">Demo Attended</label>
            <Select
  placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
  value={filterDemoAttended}
  onChange={(v) => setFilterDemoAttended(v || null)}
  allowClear
  style={{
    minWidth: 120,
    borderColor: '#4b5563',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    color: '#9ca3af',
  }}
  options={[
    { label: 'YES', value: 'YES' },
    { label: 'NO', value: 'NO' },
  ]}
/>


            </div>

            {/* Clear Filters button (right side of toolbar) */}
  <div className="ml-4">
    <Button
      onClick={clearFilters}
      icon={<UndoOutlined />}
      type="default"
      className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-50"
    >
      Clear Filters
    </Button>
  </div>
       
          </div>
         
        </div>
        </div>
        </div>

        <div className="flex items-center gap-4 mb-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Total Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {filteredLeads.length}
    </div>
  </div> 

  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Student Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {studentFilter.length}
    </div>
  </div> 

<div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Professional Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {professionalFilter.length}
    </div>
  </div> 
  
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Junior pen testing
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {juniorFilter.length}
    </div>
  </div> 

  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Senior pen testing
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {seniorFilter.length}
    </div>
  </div> 
  
</div>
       
      
        {/* Table */}
        <Table
  dataSource={filteredLeads}
  columns={demoColumns}
  rowKey={(r) => r.key}
  loading={loading}
  pagination={{ pageSize: 16, total: filteredLeads.length }}
  scroll={{ x: 2000 }}
  className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table-demo"
/>
      </div>

      {/* -------- Modals (unchanged) -------- */}
      <Modal
        title={<span className="text-lg font-bold">Select Demo Date & Time</span>}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setModalVisible(false)} disabled={modalLoading}>Cancel</Button>,
          <Button key="send" type="primary" onClick={handleModalSend} disabled={!selectedDemoRowKey || modalLoading}>
            {modalLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" />Loading</span> : 'Send Demo Link'}
          </Button>
        ]}
        width={1000}
        centered
      >
        <div className="mb-4">
          <div className="mb-2 text-sm text-gray-800">
            Sending to : <strong>{selectedLead?.FullName ?? '-'}</strong> (<span className="font-mono">{selectedLead?.Email ?? '-'}</span>)
          </div>
          <div className="mb-2 text-sm text-gray-800">
            Phone : <strong>{selectedLead?.PhoneNumber ?? '-'}</strong>
          </div>
          <div className="mb-2 text-sm text-gray-800">
            Availability Batch : <strong className='text-red-800'>{selectedLead?.AvailabilityBatch ?? '-'}</strong>
          </div>
          <div className="mb-4 text-sm text-gray-800">
            Batch day : <strong className='text-green-800'>{selectedLead?.BatchDay ?? '-'}</strong>
          </div>
        </div>

        {modalLoading ? (
          <div className="flex items-center justify-center py-20"><Spin /></div>
        ) : (
          <Table
            dataSource={demoLinks}
            columns={demoLinksColumns}
            rowKey={(r) => r.key}
            pagination={{ pageSize: 14 }}
            rowSelection={{
              type: 'radio',
              selectedRowKeys: selectedDemoRowKey ? [selectedDemoRowKey] : [],
              onChange: (selectedRowKeys, selectedRows) => onDemoRowSelect(selectedRowKeys, selectedRows),
            }}
            onRow={(record) => ({
              onClick: () => handleSelectDemoRow(record),
              role: 'radio',
              'aria-checked': selectedDemoRowKey === record.key,
              tabIndex: 0,
              onKeyDown: (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleSelectDemoRow(record);
                }
              },
            })}
            rowClassName={(record) => (record.key === selectedDemoRowKey ? 'bg-blue-50' : '')}
            scroll={{ x: 1400 }}
            size="small"
            className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
          />
        )}
      </Modal>

      {/* Action Modal */}
      <Modal
        title={<div className="flex items-center justify-center w-full"><span className="text-xl font-bold text-gray-900">Choose action for lead</span></div>}
        open={actionModalVisible}
        onCancel={() => setActionModalVisible(false)}
        footer={null}
        centered
        width={520}
        bodyStyle={{ padding: 24 }}
      >
        <div className="space-y-4">
          <div className="text-sm text-gray-700">
            Performing action for: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
            {actionRecord?.PhoneNumber ? <span className="ml-2 text-xs font-semibold text-gray-700">({actionRecord.PhoneNumber})</span> : null}
          </div>

          <div className="flex flex-col gap-3">
            <button onClick={() => handleMoveToNurturing(actionRecord)} disabled={!actionRecord || movingKeys.has(`move-nurture-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-nurture-${actionRecord?.key}`) ? 'bg-blue-400 cursor-wait' : 'bg-blue-600 hover:bg-blue-700'}`} type="button">
              {movingKeys.has(`move-nurture-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To Nurturing Stage'}
            </button>

           {/* Move to Upcoming Batch */}
<button
  onClick={() => openUpcomingModal(actionRecord)}
  disabled={!actionRecord || movingKeys.has(`move-upcoming-${actionRecord?.key}`)}
  className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? 'bg-indigo-400 cursor-wait' : 'bg-gray-600 hover:bg-gray-900'}`}
  type="button"
>
  {movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
</button>

            <button onClick={() => { setDropComments(''); setDropModalVisible(true); }} disabled={!actionRecord || movingKeys.has(`drop-lead-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`drop-lead-${actionRecord?.key}`) ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button">
              Drop The Lead
            </button>
          </div>
        </div>
      </Modal>

      {/* Upcoming Batch Modal */}
<Modal
  title={<span className="text-lg font-bold">Move To Upcoming Batch</span>}
  open={upcomingModalVisible}
  onCancel={() => setUpcomingModalVisible(false)}
  footer={null}
  centered
  width={1000}
>
  <div className="space-y-4">
    <div className="text-gray-800 text-md">
      Moving lead: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
    </div>
     <div className="mb-2 text-sm text-gray-800">
            Current Batch : <strong className='text-red-800'>{actionRecord?.AvailabilityBatch ?? '-'}</strong>
          </div>
          <div className="mb-4 text-sm text-gray-800">
            Batch day : <strong className='text-green-800'>{actionRecord?.BatchDay ?? '-'}</strong>
          </div>

    <div>
      <label className="block mb-1 text-gray-800 text-md">Email</label>
      <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 font-semibold bg-gray-100 border border-gray-200 rounded-md text-md" />
    </div>

    <div>
      <label className="block mb-2 text-gray-800 text-md">Select Batch (choose one)</label>

      {upcomingModalLoading ? (
        <div className="flex items-center justify-center py-8"><Spin /></div>
      ) : (
        <Table
          dataSource={upcomingDemoLinks}
          columns={demoLinksColumns}
          rowKey={(r) => r.key}
          pagination={{ pageSize: 6 }}
          className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
          size="small"
          scroll={{ x: 1400 }}
          rowSelection={{
            type: 'radio',
            selectedRowKeys: selectedUpcomingDemoKey ? [selectedUpcomingDemoKey] : [],
            onChange: (keys, rows) => {
              setSelectedUpcomingDemoKey(keys && keys[0] ? keys[0] : null);
            }
          }}
          onRow={(rec) => ({
            onClick: () => handleSelectUpcomingRow(rec),
            tabIndex: 0,
            onKeyDown: (e) => {
              if (e.key === 'Enter' || e.key === ' ') handleSelectUpcomingRow(rec);
            }
          })}
        />
      )}
    </div>

    <div>
      <label className="block mb-1 text-gray-800 text-md">Comments</label>
      <TextArea rows={3} value={upcomingComments} onChange={(e) => setUpcomingComments(e.target.value)} placeholder="Please give comments..." />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setUpcomingModalVisible(false)} disabled={upcomingModalLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={handleConfirmMoveToUpcomingBatch}
        disabled={!selectedUpcomingDemoKey || Boolean(upcomingModalLoading) || Boolean(upcomingMovingKey)}
        className="bg-blue-600"
      >
        {(Boolean(upcomingMovingKey) || upcomingModalLoading) ? <span className="inline-flex items-center gap-2 font-semibold"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
      </Button>
    </div>
  </div>
</Modal>


      {/* Drop Modal */}
      <Modal
        title={<span className="text-lg font-bold">Drop Lead</span>}
        visible={dropModalVisible}
        onCancel={() => setDropModalVisible(false)}
        footer={null}
        centered
        width={560}
      >
        <div className="space-y-4">
          <div className="text-sm text-gray-700">Dropping lead: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong></div>

          <div>
            <label className="block mb-1 text-sm text-gray-700">Email</label>
            <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border border-gray-200 rounded-md" />
          </div>

          <div>
            <label className="block mb-1 text-sm text-gray-700">Comments</label>
            <TextArea value={dropComments} onChange={(e) => setDropComments(e.target.value)} rows={4} placeholder="Reason / notes for dropping this lead..." />
          </div>

          <div className="flex items-center justify-end gap-3">
            <button onClick={() => setDropModalVisible(false)} className="px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-md" type="button" disabled={dropLoading}>Cancel</button>
            <button onClick={() => handleDropLeadConfirm(actionRecord)} className={`px-5 py-2.5 rounded-md text-white font-semibold ${dropLoading ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button" disabled={dropLoading}>
              {dropLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Dropping...</span> : 'Drop Lead'}
            </button>
          </div>
        </div>
      </Modal>

      {/* Demo Status Modal */}
      <Modal title={<span className="text-lg font-bold">Change Demo Attended Status</span>} visible={demoStatusModalVisible} onCancel={() => setDemoStatusModalVisible(false)} footer={null} centered width={520}>
        <div className="space-y-4">
          <div>
            <label className="block mb-1 text-gray-600 text-md">Email</label>
            <input type="text" value={demoStatusRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md" />
          </div>

          <div>
            <label className="block mb-1 text-gray-600 text-md">Status</label>
            <Select value={demoStatusValue} onChange={(v) => setDemoStatusValue(v)} placeholder="Select status" style={{ width: '20%' }} options={[{ label: 'YES', value: 'YES' }, { label: 'NO', value: 'NO' }]} disabled={demoStatusLoading} />
          </div>

          <div className="flex items-center justify-end gap-3">
            <Button onClick={() => setDemoStatusModalVisible(false)} disabled={demoStatusLoading}>Cancel</Button>
            <Button type="primary" onClick={handleChangeDemoStatus} disabled={demoStatusLoading || !demoStatusValue} className="bg-blue-600">
              {demoStatusLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Status'}
            </Button>
          </div>
        </div>
      </Modal>

     <Modal
  title={<span className="text-lg font-bold">Change Enrollment Type</span>}
  open={enrollmentModalVisible}
  onCancel={() => setEnrollmentModalVisible(false)}
  footer={null}
  centered
  width={620}
>
  <div className="space-y-5">

    {/* FULL NAME */}
    <div className="text-gray-800 text-md">
      Full Name :{" "}
      <strong className="text-red-800">
        {enrollmentRecord?.FullName ?? "-"}
      </strong>
    </div>

    {/* EMAIL */}
    <div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={enrollmentRecord?.Email ?? ""}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    {/* ENROLLMENT TYPE DROPDOWN */}
    <div>
      <label className="block mb-1 text-gray-600 text-md">
        Enrollment Type
      </label>

      <Select
        value={enrollmentValue}
        onChange={(v) => setEnrollmentValue(v)}
        placeholder="Select Enrollment Type"
        style={{ width: "100%" }}
        disabled={enrollmentLoading}
        options={[
          {
            label: "JUNIOR PENETRATION TESTER",
            value: "JUNIOR PENETRATION TESTER",
          },
          {
            label: "SENIOR PENETRATION TESTER",
            value: "SENIOR PENETRATION TESTER",
          },
        ]}
      />
    </div>

    {/* BUTTONS */}
    <div className="flex items-center justify-end gap-3 mt-4">
      <Button
        onClick={() => setEnrollmentModalVisible(false)}
        disabled={enrollmentLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleChangeEnrollmentType}
        disabled={enrollmentLoading || !enrollmentValue}
        className="bg-blue-600"
      >
        {enrollmentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Changing...
          </span>
        ) : (
          "Change Enrollment Type"
        )}
      </Button>
    </div>
  </div>
</Modal>


<Modal
  title={<span className="text-lg font-bold">Change Availability Batch</span>}
  open={changeBatchModalVisible}
  onCancel={() => setChangeBatchModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">

    {/* FULL NAME */}
    <div className="text-gray-800 text-md">
      Full Name :{" "}
      <strong className="text-red-800">
        {changeBatchRecord?.FullName ?? "-"}
      </strong>
    </div>
    
    <div className="text-gray-800 text-md">
      Current Batch :{" "}
      <strong className="text-cyan-800">
        {changeBatchRecord?.AvailabilityBatch ?? "-"}
      </strong>
    </div>
    
     <div className="text-gray-800 text-md">
      Current Batch Day :{" "}
      <strong className="text-green-800">
        {changeBatchRecord?.BatchDay ?? "-"}
      </strong>
    </div>

    {/* EMAIL */}
    <div>
      <label className="block mb-1 font-medium text-gray-700">Email</label>
      <input
        type="text"
        value={changeBatchRecord?.Email ?? ""}
        readOnly
        className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border rounded"
      />
    </div>

    {/* DATE PICKER */}
    <div>
      <label className="block mb-1 font-medium text-gray-700">
        Select New Batch Date
      </label>
      <DatePicker
        value={changedBatchDate}
        onChange={(d) => setChangedBatchDate(d)}
        format="DD-MM-YYYY"
        className="w-full"
        disabled={changeBatchLoading}
      />
    </div>

    {/* ACTIONS */}
    <div className="flex justify-end gap-3 pt-2">
      <Button
        onClick={() => setChangeBatchModalVisible(false)}
        disabled={changeBatchLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        className="bg-blue-600"
        disabled={!changedBatchDate || changeBatchLoading}
        onClick={handleChangeAvailabilityBatch}
      >
        {changeBatchLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Change Batch"
        )}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title="Change Lead Status"
  open={leadStatusModalVisible}
  onCancel={() => setLeadStatusModalVisible(false)}
  footer={null}
  destroyOnClose
>
  <div className="space-y-4">

    {/* Lead Info */}
    <div className="p-3 space-y-1 border rounded-md bg-gray-50">
      <p className="text-sm">
        <span className="font-bold text-gray-600">Name:</span>{" "}
        <span className="font-bold text-gray-900">
          {leadStatusRecord?.FullName || leadStatusRecord?.Name || "-"}
        </span>
      </p>

      <p className="text-sm">
        <span className="font-bold text-gray-600">Email:</span>{" "}
        <span className="font-bold text-gray-900">
          {leadStatusRecord?.Email || "-"}
        </span>
      </p>
    </div>

    {/* Status Dropdown */}
    <Select
      placeholder="Select Lead Status"
      value={leadStatusValue}
      onChange={setLeadStatusValue}
      className="w-[50%]"
      options={[
        { label: "HOT LEAD", value: "HOT LEAD" },
        { label: "WARM LEAD", value: "WARM LEAD" },
        { label: "COLD LEAD", value: "COLD LEAD" },
      ]}
    />

    {/* Action Button */}
    <Button
      type="primary"
      block
      loading={leadStatusLoading}
      onClick={handleChangeLeadStatus}
      disabled={!leadStatusValue}
    >
      Change Lead Status
    </Button>
  </div>
</Modal>


  <Modal
  title={<span className="text-lg font-bold">Change Call Status</span>}
  open={callStatusModalVisible}
  onCancel={() => setCallStatusModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div>
       <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{callStatusRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={callStatusRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Call Status</label>
      <Select
        value={callStatusValue}
        onChange={(v) => setCallStatusValue(v)}
        placeholder="Select status"
        style={{ width: '100%' }}
        options={[
          { label: 'INTERESTED', value: 'INTERESTED' },
          { label: 'NOT INTERESTED', value: 'NOT INTERESTED' },
          { label: 'FOLLOW UP', value: 'FOLLOW UP' },
          { label: 'CONNECT TO INSTRUCTOR', value: 'CONNECT TO INSTRUCTOR' },
        ]}
        disabled={callStatusLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setCallStatusModalVisible(false)} disabled={callStatusLoading}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleChangeCallStatus}
        disabled={callStatusLoading || !callStatusValue}
        className="bg-blue-600"
      >
        {callStatusLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Call Status'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Demo Comment</span>}
  open={commentModalVisible}
  onCancel={() => {
    setCommentModalVisible(false);
    setCommentRecord(null);
    setCommentValue("");
  }}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">
          {commentRecord?.FullName ?? "-"}
        </strong>
      </div>

      <div className="mb-2 text-sm text-gray-800">
        Email :{" "}
        <strong className="text-blue-800">
          {commentRecord?.Email ?? "-"}
        </strong>
      </div>

      <div className="text-sm text-gray-800">
        Phone Number :{" "}
        <strong className="text-green-800">
          {commentRecord?.PhoneNumber ?? "-"}
        </strong>
      </div>
    </div>

    <Input.TextArea
      rows={5}
      value={commentValue}
      onChange={(e) => setCommentValue(e.target.value)}
      placeholder="Enter nurturing lead comment..."
      disabled={commentLoading}
      maxLength={1000}
      showCount
    />

    <div className="flex items-center justify-end gap-3">
      <Button
        onClick={() => {
          setCommentModalVisible(false);
          setCommentRecord(null);
          setCommentValue("");
        }}
        disabled={commentLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleUpdateComment}
        disabled={commentLoading || !commentValue.trim()}
        className="bg-blue-600"
      >
        {commentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Update Comment"
        )}
      </Button>
    </div>
  </div>
</Modal>



    </div>
  );
}
